import './print-trim.header.scss';
import { UiManager } from '../../../../../layout-editor/manager/ui/ui.manager';
import ppmFavicon from '../../../../../assets/img/logo/ppmfavicon.png';
import { useCallback, useState } from 'react';
import { NewPage } from '../../../../../utilities/new-page';
import { webPagePath } from '../../../../../models/web-page-path';
import { useParams } from 'react-router-dom';
import { PathParams } from '../../../../../routes/routing-path';

type Props = {
  name: string,
  delivery: 'store' | 'private',
}
type OpenType = 'none' | 'file' | 'edit' | 'window' | 'info' | 'conf' | 'help';
const PrintTrimHeader = (props: Props) => {
  const {name, delivery} = props;
  const { kijshopCd, shopOrderId } = useParams<PathParams>();

  // - State
  const [disabled, setIsDisabled] = useState(false);
  // // -- お客様名、配送店舗 --
  // const [name, setName] = useState('');
  // const [delivery, setDelivery] = useState('');
  // -- どのメニューを開いているか --
  const [openType, setOpenType] = useState<OpenType>('none');
  // - Callback -
  // -- 開閉状態のメニュー変更用 --
  const handlerChangeOpenType = useCallback((v: OpenType) => {
    if (disabled) return;
    if (v === 'help') {
      NewPage.tab(webPagePath.help);
    }
    setOpenType(v);
  }, [disabled]);

  return (
    <div
      className="trim_header"
      onClick={() => UiManager.ins.emit('r->l:dis-select')}
    >
      <div className="trim_header__left">
        <div className="trim_header__logo">
          <img
            src={ppmFavicon}
            alt=""
          />
        </div>

        {/* メニューリスト閉じる用背景 */}
        {openType === 'none' ? (<></>) : <div
          className="pull_down_menu_list__dimmer"
          onClick={() => {
            handlerChangeOpenType('none');
          }}
        />}
        {/*{pageType === 'edit' ? (*/}
        {/*  <div className="trim_header__menu">*/}
        {/*    <span onClick={() => handlerChangeOpenType('edit')}>*/}
        {/*      編集画面設定*/}
        {/*    </span>*/}
        {/*    {openType === 'edit' ? (*/}
        {/*      <MenuEdit*/}
        {/*        callbackMenu={(v) => {*/}
        {/*          callbackMenu({*/}
        {/*            ...initMenu,*/}
        {/*            fitType: v,*/}
        {/*          });*/}
        {/*        }}*/}
        {/*      />*/}
        {/*    ) : (<></>)}*/}
        {/*  </div>*/}
        {/*) : (<></>)}*/}

        <div className="trim_header__menu menu_help">
          <span
            onClick={() => handlerChangeOpenType('help')}
          >
            ヘルプ
          </span>
        </div>
        {/*{pageType === 'edit' ? <></> : <div className="trim_header__space" />}*/}
        <div>
          <div>【お客様名】&nbsp;{name}</div>
          <div>【配送店舗】&nbsp;{delivery === 'store' ? '店舗配送' : '個別配送'}</div>
        </div>
      </div>
      {/*<div className="trim_header__right">*/}
      {/*  <MenuInfo duplicateCheckedList={duplicateCheckedList} />*/}
      {/*</div>*/}
    </div>
  );
};

export default PrintTrimHeader;
